import { Link as RouterLink } from "react-router-dom";
// components
import Page from "../../components/Page";
import { LoginForm } from "../../components/auth/login";
import { UserTypeLeft } from "../../components/auth/register";
// sections

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function Login() {
  return (
    <Page title="Login">
      <section id="login_area">
        <div className="container">
          <div className="row">
            <UserTypeLeft />
            <div className="col-lg-8">
              <div className="signup_block login_block mt-lg-0 mt-4">
                <div className="text-center mb-3 mt-4">
                  <h2 className="fs-24 mb-3 fancy_title">Login</h2>
                </div>
                <div className="steps_block">
                  <div className="row">
                    <div className="col-lg-8 offset-lg-2 col-md-12">
                      <LoginForm />
                    </div>
                    <div className="col-lg-12 mt-4">
                      <div className="card_registersmo">
                        <p>
                          Don&apos;t have an account?
                          <RouterLink to="/auth/select-user-type">
                            Register here
                          </RouterLink>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 d-lg-none d-md-block d-block">
              <div className="signup_left mt-lg-0 mt-4">
                <div className="">
                  <div className="accordion" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingOne">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="false"
                          aria-controls="collapseOne"
                        >
                          Lorem ipsum dolor
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <ul className="m-0 ps-3">
                            <li>Lorem ipsum dolor sit amet, consectetur</li>
                            <li>
                              sed do eiusmod tempor incididunt ut labore et
                              dolore magna aliqua.
                            </li>
                            <li>Lorem ipsum dolor sit amet, consectetur</li>
                            <li>Lorem ipsum dolor sit amet, consectetur</li>
                            <li>Lorem ipsum dolor sit amet, consectetur</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Page>
  );
}
